export default {"gitHash":"fcaa6942ffe6a9e0772f8f34122e34135223ed85","gitHashShort":"fcaa694","time":1644657039561,"platform":"linux","arch":"x64"};